import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FileSpreadsheet, FileText, FileArchive } from 'lucide-react';
import Button from './Button';
import { exportReport } from '../../services/reportExportService';

const ICONS = { xlsx: FileSpreadsheet, pdf: FileText, zip: FileArchive };

const Group = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-right: 8px;
  vertical-align: middle;
`;

/**
 * AKM POC §7.1 — tablo araç çubuğundaki sunucu tarafı dışa aktarma düğmeleri (tam veri, o anki süzgeçler). Dosya küçükse
 * hemen iner; büyükse arka planda hazırlanır (interceptor "Dışa Aktarmalarım" toast'ını gösterir). Bir düğme çalışırken
 * diğerleri kilitlenir. labels ya da getLabels() — sütun başlıkları ve ortak etiketler (web dili). keepSort: sıralama
 * (orderBy/orderDir) dosyaya taşınır — varsayılan kapalı (kaynak kendi sırasını uygular).
 */
export default function ReportExportButtons({
  url, params, labels, getLabels, formats = ['xlsx', 'pdf'], formatLabels = {}, disabled = false, onDone, keepSort = false,
}) {
  const { t } = useTranslation();
  const [running, setRunning] = useState(null);

  const run = async (format) => {
    if (running) return;
    setRunning(format);
    try {
      const result = await exportReport(url, {
        format,
        params: params || {},
        labels: (getLabels ? getLabels() : labels) || {},
        ...(keepSort ? { keepSort: true } : {}),
      });
      onDone?.(result, format);
    } finally {
      setRunning(null);
    }
  };

  return (
    <Group data-testid="report-export-buttons">
      {formats.map((format) => {
        const Icon = ICONS[format] || FileText;
        return (
          <Button
            key={format}
            type="button"
            variant="outline"
            data-action={`export-${format}`}
            loading={running === format}
            disabled={disabled || (running !== null && running !== format)}
            onClick={() => run(format)}
          >
            <Icon size={16} aria-hidden="true" />
            {formatLabels[format] ?? t(`reportExport.${format}`)}
          </Button>
        );
      })}
    </Group>
  );
}
